// import React from 'react'
import { BrowserRouter, Routes, Route, Navigate, useParams } from 'react-router-dom';
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import AboutPage from './pages/About.jsx'
import Homepage from './pages/Homepage.jsx';
import StudioPage from './pages/Studio.jsx';
import GenerativeContentPage from './pages/GenerativeContentPage.jsx';
import ArtDepartmentPage from './pages/ArtDepartment.jsx';
import FinalPixelPage from './pages/FinalPixel.jsx';
import StagesPage from './pages/Stages.jsx';
import VfxPage from './pages/Vfx.jsx';
import VfxAllPage from './pages/VfxAll.jsx';
import LabsPage from './pages/Labs.jsx';
import ContactPage from './pages/Contact.jsx';
import CareersPage from './pages/Careers.jsx';
import StagesSubpage from './components/StagesSubpage.jsx';
import CaseStudyPage from './pages/CaseStudy.jsx';
import AlternativeFormatsPage from './pages/AlternativeFormatsPage.jsx';
import SearchPage from './pages/Search.jsx';
import NotFound from './pages/NotFound.jsx';
import './index.css'


ReactDOM.createRoot(document.getElementById("root")).render(
  <BrowserRouter>
    <Routes>
      {/* Redirect /research/** to /labs */}
      <Route path="/research/*" element={<Navigate to="/en/labs" replace />} />

      {/* Redirect root to default language */}
      <Route path="/" element={<Navigate to="/en" />} />

      {/* Language-prefixed routes */}
      <Route path="/:lang/*" element={<LocalizedRoutes />} />

      {/* Catch-all for any unmatched route that doesn't match "/:lang/*" */}
      <Route path="*" element={<Navigate to="/en/not-found" replace />} />

    </Routes>
  </BrowserRouter>
);

function LocalizedRoutes() {
  const { lang } = useParams(); // 'en' or 'ko'

  // mapping languages to Contentful Codes
  const localeMap = {
    en: "en-US",
    ko: "ko"
  };

  const contentfulLocale = localeMap[lang];

  // If the lang is invalid (not in localeMap), redirect to 404
  if (!contentfulLocale) {
    return <Navigate to="/en/not-found" replace />;
  }

  return (
    <Routes>
      <Route path="/" element={<App lang={contentfulLocale} />}>
        <Route index element={<Homepage lang={contentfulLocale} />} />
        <Route path="projects/:slug" element={<CaseStudyPage lang={contentfulLocale} />} />

        <Route path="studios" element={<StudioPage lang={contentfulLocale} />} />
        <Route path="studios/generative-visuals" element={<GenerativeContentPage lang={contentfulLocale} />} />
        <Route path="studios/generative-content/art-department" element={<ArtDepartmentPage lang={contentfulLocale} />} />
        <Route path="studios/generative-content/final-pixel" element={<FinalPixelPage lang={contentfulLocale} />} />
        <Route path="studios/stages" element={<StagesPage lang={contentfulLocale} />} />
        <Route path="studios/alternative-formats" element={<AlternativeFormatsPage lang={contentfulLocale} />} />
        <Route path="studios/stages/:slug" element={<StagesSubpage lang={contentfulLocale} />} />

        <Route path="vfx" element={<VfxPage lang={contentfulLocale} />} />
        <Route path="vfx/all" element={<VfxAllPage lang={contentfulLocale} />} />

        <Route path="labs" element={<LabsPage lang={contentfulLocale} />} />

        <Route path="about" element={<AboutPage lang={contentfulLocale} />} />
        <Route path="about/careers" element={<CareersPage lang={contentfulLocale} />} />

        <Route path="contact" element={<ContactPage lang={contentfulLocale} />} />
        <Route path="search" element={<SearchPage lang={contentfulLocale} />} />

        <Route path="not-found" element={<NotFound lang={contentfulLocale} />} />
        <Route path="*" element={<NotFound lang={contentfulLocale} />} />

      </Route>
    </Routes>
  );
}